import { flagFactory } from '../icon';
import Svg from './cy.svg';

export default flagFactory(Svg);
